import * as React from "react";
export const NotificationIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 29" {...props}>
    <path
      d="M23.9 24.2l-2.1-3.4c-.9-1.6-1.4-3.4-1.4-5.2v-3c0-3.8-2.5-7-6-8V2.4C14.4 1.1 13.3 0 12 0S9.6 1.1 9.6 2.4v2.1c-3.5 1-6 4.2-6 8v3c0 1.8-.5 3.7-1.4 5.2L.1 24.1c-.1.2-.1.4 0 .6s.3.3.5.3h22.7c.2 0 .4-.1.5-.3.2-.1.2-.3.1-.5zM8.2 26.3c.7 1.4 2.1 2.4 3.8 2.4s3.1-1 3.8-2.4H8.2z"
      fill="#979797"
    />
  </svg>
);
